interface ScoreBarsProps {
  resumeScore: number;
  answersScore: number;
  compatScore: number;
  totalScore: number;
  compact?: boolean;
}

export default function ScoreBars({ resumeScore, answersScore, compatScore, totalScore, compact = false }: ScoreBarsProps) {
  const maxPerBlock = 100;
  const resumePct = Math.min((resumeScore / maxPerBlock) * 100, 100);
  const answersPct = Math.min((answersScore / maxPerBlock) * 100, 100);
  const compatPct = Math.min((compatScore / maxPerBlock) * 100, 100);

  if (compact) {
    return (
      <div className="flex items-center gap-3">
        <div className="flex gap-1 flex-1">
          <div className="h-2 rounded-full overflow-hidden flex-1 bg-purple-100">
            <div className="h-full rounded-full bg-purple-600 transition-all" style={{ width: `${resumePct}%` }}></div>
          </div>
          <div className="h-2 rounded-full overflow-hidden flex-1 bg-emerald-100">
            <div className="h-full rounded-full bg-emerald-600 transition-all" style={{ width: `${answersPct}%` }}></div>
          </div>
          <div className="h-2 rounded-full overflow-hidden flex-1 bg-amber-100">
            <div className="h-full rounded-full bg-amber-600 transition-all" style={{ width: `${compatPct}%` }}></div>
          </div>
        </div>
        <span className="text-sm font-heading font-bold text-foreground-900 min-w-[3ch] text-right">{totalScore}</span>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        <span className="text-xs text-purple-700 font-medium w-20">Резюме</span>
        <div className="flex-1 h-2 rounded-full overflow-hidden bg-purple-100">
          <div className="h-full rounded-full bg-purple-600 transition-all" style={{ width: `${resumePct}%` }}></div>
        </div>
        <span className="text-xs font-medium text-foreground-700 w-8 text-right">{resumeScore}</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-xs text-emerald-700 font-medium w-20">Анкета</span>
        <div className="flex-1 h-2 rounded-full overflow-hidden bg-emerald-100">
          <div className="h-full rounded-full bg-emerald-600 transition-all" style={{ width: `${answersPct}%` }}></div>
        </div>
        <span className="text-xs font-medium text-foreground-700 w-8 text-right">{answersScore}</span>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-xs text-amber-700 font-medium w-20">Совмест.</span>
        <div className="flex-1 h-2 rounded-full overflow-hidden bg-amber-100">
          <div className="h-full rounded-full bg-amber-600 transition-all" style={{ width: `${compatPct}%` }}></div>
        </div>
        <span className="text-xs font-medium text-foreground-700 w-8 text-right">{compatScore}</span>
      </div>
      <div className="flex items-center gap-3 pt-1">
        <span className="text-xs text-foreground-500 font-medium w-20">Итог</span>
        <div className="flex-1 h-2.5 rounded-full overflow-hidden bg-background-200">
          <div
            className="h-full rounded-full transition-all"
            style={{
              width: `${Math.min((totalScore / 300) * 100, 100)}%`,
              background: `linear-gradient(to right, #9333ea, #059669, #d97706)`,
            }}
          ></div>
        </div>
        <span className="text-sm font-heading font-bold text-foreground-900 w-8 text-right">{totalScore}</span>
      </div>
    </div>
  );
}